var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"width":"100%"},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"chart-container"},[_c('apexchart',{attrs:{"type":"pie","width":"380","options":_vm.chartOptions,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }